"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadWorldCharacterUpdate = void 0;
const WorldCharacter_1 = require("../../classes/WorldCharacter");
const addWorldCharacterEmote_1 = require("../addWorldCharacterEmote");
const addWorldCharacterMarker_1 = require("../addWorldCharacterMarker");
const pixel_pigeon_1 = require("pixel-pigeon");
const createCharacterSprite_1 = require("../ui/components/createCharacterSprite");
const getConstants_1 = require("../getConstants");
const getDefaultedClothesDye_1 = require("../defaulted-cosmetics/getDefaultedClothesDye");
const getDefaultedHairDye_1 = require("../defaulted-cosmetics/getDefaultedHairDye");
const getDefaultedMask_1 = require("../defaulted-cosmetics/getDefaultedMask");
const getDefaultedOutfit_1 = require("../defaulted-cosmetics/getDefaultedOutfit");
const loadWorldCharacterUpdate = (worldCharacterUpdate) => {
    var _a, _b;
    const constants = (0, getConstants_1.getConstants)();
    const questInstances = {};
    if (typeof worldCharacterUpdate.questInstances !== "undefined") {
        for (const questID in worldCharacterUpdate.questInstances) {
            const questInstance = worldCharacterUpdate.questInstances[questID];
            if (typeof questInstance === "undefined") {
                throw new Error("No quest instance.");
            }
            questInstances[questID] = {
                isCompleted: (_a = questInstance.isCompleted) !== null && _a !== void 0 ? _a : false,
                isStarted: (_b = questInstance.isStarted) !== null && _b !== void 0 ? _b : false,
                monsterKills: questInstance.monsterKills,
            };
        }
    }
    const worldCharacter = new WorldCharacter_1.WorldCharacter({
        clothesDyeItemID: worldCharacterUpdate.clothesDyeItemID,
        direction: worldCharacterUpdate.direction,
        figureID: worldCharacterUpdate.figureID,
        hairDyeItemID: worldCharacterUpdate.hairDyeItemID,
        id: worldCharacterUpdate.characterID,
        isRenewing: worldCharacterUpdate.isRenewing,
        maskItemID: worldCharacterUpdate.maskItemID,
        openedChestIDs: worldCharacterUpdate.openedChestIDs,
        order: worldCharacterUpdate.order,
        outfitItemID: worldCharacterUpdate.outfitItemID,
        playerID: worldCharacterUpdate.playerID,
        position: {
            x: worldCharacterUpdate.x,
            y: worldCharacterUpdate.y,
        },
        questInstances,
        resources: typeof worldCharacterUpdate.resources !== "undefined"
            ? {
                hp: worldCharacterUpdate.resources.hp,
                maxHP: worldCharacterUpdate.resources.maxHP,
                maxMP: worldCharacterUpdate.resources.maxMP,
                mp: worldCharacterUpdate.resources.mp,
            }
            : undefined,
        skinColorID: worldCharacterUpdate.skinColorID,
        step: worldCharacterUpdate.step,
        tilemapID: worldCharacterUpdate.tilemapID,
    });
    const tileSize = constants["tile-size"];
    worldCharacter.entityID = (0, pixel_pigeon_1.createEntity)({
        buttons: [
            {
                buttonID: (0, pixel_pigeon_1.createButton)({
                    allowsMousedownThrough: true,
                    height: tileSize,
                    width: tileSize,
                }),
                onClick: () => {
                    worldCharacter.wasClicked = true;
                },
            },
        ],
        height: tileSize,
        layerID: "characters",
        levelID: worldCharacter.tilemapID,
        position: {
            x: worldCharacter.position.x * tileSize,
            y: worldCharacter.position.y * tileSize,
        },
        width: tileSize,
        zIndex: worldCharacter.order,
    });
    (0, createCharacterSprite_1.createCharacterSprite)({
        clothesDyeID: () => (0, getDefaultedClothesDye_1.getDefaultedClothesDye)(worldCharacter.hasClothesDyeItem()
            ? worldCharacter.clothesDyeItemID
            : undefined).id,
        direction: () => worldCharacter.direction,
        entity: {
            animationStartedAt: () => worldCharacter.hasMovedAt() ? worldCharacter.movedAt : null,
            entityID: worldCharacter.entityID,
            step: () => worldCharacter.step,
        },
        figureID: () => worldCharacter.figureID,
        hairDyeID: () => (0, getDefaultedHairDye_1.getDefaultedHairDye)(worldCharacter.hasHairDyeItem()
            ? worldCharacter.hairDyeItemID
            : undefined).id,
        maskID: () => (0, getDefaultedMask_1.getDefaultedMask)(worldCharacter.hasMaskItem() ? worldCharacter.maskItemID : undefined).id,
        outfitID: () => (0, getDefaultedOutfit_1.getDefaultedOutfit)(worldCharacter.hasOutfitItem()
            ? worldCharacter.outfitItemID
            : undefined).id,
        skinColorID: () => worldCharacter.skinColorID,
    });
    if (typeof worldCharacterUpdate.marker !== "undefined") {
        (0, addWorldCharacterMarker_1.addWorldCharacterMarker)(worldCharacter.id, worldCharacterUpdate.marker);
    }
    if (typeof worldCharacterUpdate.emote !== "undefined") {
        (0, addWorldCharacterEmote_1.addWorldCharacterEmote)(worldCharacter.id, worldCharacterUpdate.emote.emoteID, (0, pixel_pigeon_1.getCurrentTime)() - worldCharacterUpdate.emote.sinceUsed);
    }
};
exports.loadWorldCharacterUpdate = loadWorldCharacterUpdate;
